module.exports = __webpack_public_path__ + "static/img/FITmenu11.bdbb211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu11.png
// module id = qq3u
// module chunks = 1